import { DateTime } from 'luxon';
import { OrderReview, ReviewFeedback, ReviewStatus, ReviewsOrder, ReviewsUser } from './order-reviews';

export namespace OrderReviewParsers {
  export class OrderReviewJson {
    id!: number;
    user!: ReviewsUser;
    order!: ReviewsOrder;
    rating?: ReviewFeedback;
    createdAt!: string;
    reviewedOn?: string;
    status!: ReviewStatus;
  }

  export function toOrderReview(input: OrderReviewJson): OrderReview {
    return {
      ...input,
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
      reviewedOn: input.reviewedOn ? DateTime.fromISO(input.reviewedOn, { setZone: true }) : undefined,
    };
  }
}
